import {
  Button,
  FormField,
  Modal,
  RangeDatePicker,
  TextInput,
  Variants
} from "@sede-x/shell-ds-react-framework";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { TOutboundBatchSearchCriteria } from "./tracker.types";

export const OutboundBatchesSearch = ({
  open,
  searchCriteria,
  onClose,
  onSubmit
}: {
  open: boolean;
  searchCriteria: TOutboundBatchSearchCriteria;
  onClose: () => void;
  onSubmit: (elm: TOutboundBatchSearchCriteria) => void;
}) => {
  const [localSearchCriteria, setLocalSearchCriteria] =
    useState<TOutboundBatchSearchCriteria>(searchCriteria);

  const disabledDate = (current: Dayjs) =>
    current
      ? current.isBefore(new Date("2024-01-01"), "date") || current.isAfter(new Date(), "date")
      : false;
  return (
    <Modal
      title="Search outbound batches queue"
      width={"800px"}
      height={"600px"}
      mask={true}
      open={open}
      onClose={onClose}>
      <div>
        <FormField size={"medium"} label="Queued between">
          <RangeDatePicker
            picker="date"
            format="MM/DD/YYYY"
            allowClear={true}
            disabledDate={disabledDate}
            autoFocus
            value={[dayjs(localSearchCriteria.startDate), dayjs(localSearchCriteria.endDate)]}
            onChange={values => {
              setLocalSearchCriteria(c => ({
                ...c,
                startDate: values?.[0]?.toISOString() ?? "",
                endDate: values?.[1]?.toISOString() ?? ""
              }));
            }}
          />
        </FormField>
        <FormField size={"medium"} label="Batch name">
          <TextInput
            placeholder="Comma seperated batch names"
            value={localSearchCriteria.name}
            onChange={e =>
              setLocalSearchCriteria(c => ({
                ...c,
                name: e.target.value
              }))
            }
          />
        </FormField>
        <div style={{ paddingBottom: "200px" }}></div>
        <div className="from-button-wrap">
          <Button variant={Variants.Outlined} onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" onClick={() => onSubmit(localSearchCriteria)}>
            Search
          </Button>
        </div>
      </div>
    </Modal>
  );
};
